import React from 'react'
import { PostsSelector } from 'components/atoms/PostsSelector'
import { StatusBadge } from 'components/atoms'
import I18n from '../../../../core/i18n'
import { ContentBody, ContentHeader, RowSection, SectionContent } from '../layout'
import styled, { AnyStyledComponent } from 'styled-components'
import { COLORS } from '../../../../static/constants'
import DataRow from './DataRow'
import { emptyValue, formatDateTime } from './helpers'
import { IOtaReservation } from 'static/interfaces'
import { IOtaReservationTourEditor } from 'utils/otaReservation/useTourEditor'

interface IProps {
  otaReservation: IOtaReservation
  isEditing: boolean
  editor: IOtaReservationTourEditor
}
const OperationsTourSectionContent = ({ otaReservation, isEditing, editor }: IProps) => {
  const tourDateTime = `${formatDateTime(otaReservation.start_at)} - ${formatDateTime(
    otaReservation.end_at
  )}`

  return (
    <SectionContent>
      <ContentHeader>ツアー情報</ContentHeader>
      <ContentBody>
        <RowSection>
          <DataRow
            label="ツアー催行日時"
            content={
              isEditing && editor.tourDatetimeEditable ? (
                <TourDateTimeInputs>
                  <input
                    type="date"
                    value={editor.tourDateEdit}
                    onChange={event => editor.setTourDateEdit(event.target.value)}
                  />
                  <input
                    type="time"
                    value={editor.tourStartAtEdit}
                    onChange={event => editor.setTourStartAtEdit(event.target.value)}
                  />
                </TourDateTimeInputs>
              ) : otaReservation.jwt_tour_id ? (
                <a
                  href={`/agent/tours/weekly?start=${otaReservation.tour_date}&tour_id=${otaReservation.jwt_tour_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {tourDateTime} (id:{otaReservation.jwt_tour_id})
                </a>
              ) : (
                tourDateTime
              )
            }
            description={
              otaReservation.manual_time_override
                ? I18n.t('flash.ota_reservations.manual_time_override_label')
                : undefined
            }
          />
          <DataRow label="ツアー種別" content={emptyValue(otaReservation.post?.post_type)} />
          <DataRow
            label="ツアー名"
            content={
              isEditing && editor.postEditable ? (
                <PostsSelector
                  posts={editor.posts}
                  selectedPostIds={editor.selectedPost ? [editor.selectedPost.id] : []}
                  onChangePostIds={editor.onChangePostIds}
                  label=""
                  isMulti={false}
                  isClearable={false}
                  isFullLabel={true}
                  placeholder="ツアーを選択してください"
                />
              ) : otaReservation.jwt_post_id ? (
                <a
                  href={`/posts/${otaReservation.jwt_post_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {emptyValue(otaReservation.post?.name)}
                </a>
              ) : (
                emptyValue(otaReservation.post?.name || '未設定')
              )
            }
          />
          <DataRow label="商品コード" content={emptyValue(otaReservation.tour_product_id)} />
        </RowSection>
        <RowSection>
          <DataRow
            label="Checked In"
            content={
              otaReservation.checkin_status === 'no_show' ? (
                <StatusBadge type="danger" label="No Show" />
              ) : (
                <StatusBadge
                  type={otaReservation.checkin_status === 'checked_in' ? 'success' : 'caution'}
                  label={otaReservation.checkin_status === 'checked_in' ? 'YES' : 'NO'}
                />
              )
            }
          />
          <DataRow label="Tour Group ID" content={emptyValue(otaReservation.jwt_tour_group_id)} />
          <DataRow label="OTAタイトル" content={emptyValue(otaReservation.tour_title)} />
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default OperationsTourSectionContent

const TourDateTimeInputs: AnyStyledComponent = styled.div`
  display: flex;
  gap: 4px 8px;
  flex-wrap: wrap;

  input {
    height: 40px;
    padding: 8px 12px;
    border: 1px solid ${COLORS.divider};
    border-radius: 4px;
    font-size: 14px;
  }
`
